import { createApp } from "vue";

import App from "@/App.vue";
import Plugins from "@/plugins";
import router from "@/router/index.js";

const app = createApp(App);
app.use(Plugins);
app.use(router);

// Add animate.css
import "animate.css";

// Add Fontawesome (tree-shaken)
import "@fortawesome/fontawesome-svg-core/styles.css";
import FontAwesomePlugin from "@/plugins/fontawesome";
app.use(FontAwesomePlugin);

import "@/assets/style.scss";

app.mount("#app");

// Preload MappedIn SDK after app is mounted and idle
// This ensures it's ready when needed but never blocks initial render
if (typeof window !== "undefined") {
    const preloadMappedin = () => {
        // Dynamic import will trigger download but not block
        // Vite will handle the chunk splitting automatically
        import("@mappedin/mappedin-js")
            .then(() => {
                console.log("[Preload] MappedIn SDK cached successfully");
            })
            .catch(() => {
                // Silently ignore - user might never visit map page
            });
    };

    // Use requestIdleCallback if available, otherwise setTimeout
    if ("requestIdleCallback" in window) {
        requestIdleCallback(preloadMappedin, { timeout: 10000 });
    } else {
        setTimeout(preloadMappedin, 3000);
    }
}
